import { removeTrailingSlash } from "./removeTrailingSlash"

export const getApiRoot = ()=>removeTrailingSlash(window.inIframe ? window.parameters.ecommerceApi : window.PropzmediaConfig.apiRoot)